import { singlePageProps } from '@lib/singlePageProps';
import { BookOpenIcon, CollectionIcon } from '@heroicons/react/outline';
import { RocketIcon } from '@components/common';
import {
  Header,
  GetStarted,
  SmallQuote,
  AuthAtEdge,
  Code,
  Powerful,
  Resources,
  ExampleProjs
} from '@components/solutions';
import { URLS } from '@lib';
import { PageProps } from '../../types/page-props';

export default function NextJSAuthenticationPage(props: PageProps) {
  const { image, text, body } = props;
  const resources = [
    {
      title: 'Documentation',
      description: body.find(
        (text: Record<string, unknown>) => text.key === 'docsDescription'
      ),
      icon: BookOpenIcon
    },
    {
      title: 'Guide',
      description: body.find(
        (text: Record<string, unknown>) => text.key === 'blogDescription'
      ),
      icon: CollectionIcon
    },
    {
      title: 'Get Started',
      description: body.find(
        (text: Record<string, unknown>) => text.key === 'getStartedDescription'
      ),
      icon: RocketIcon
    }
  ];

  const signIn = `import { SignIn } from '@clerk/nextjs';
  ...
    return (
      <>
        <BackgroundImage />
        <SignIn />
      </>
    );
  ...`;

  const userProfile = `import { UserProfile } from '@clerk/nextjs';
  ...
    return (
      <>
        <CustomHeader />
        <UserProfile />
      </>
    );
  ...`;

  return (
    <>
      <section className="mt-10">
        <Header
          title={text.headerTitle as string}
          boldTitle={text.headerBoldTitle as string}
          subheader={text.headerSubheader as string}
        />
      </section>
      <GetStarted doc={URLS.nextjsDocs} />
      <section className="mt-12" id="quote">
        <SmallQuote
          quote={text.quoteBody as string}
          name={text.quoteName as string}
          title={text.quoteTitle as string}
          image={image.quote}
        />
      </section>
      <section className="my-32" id="auth-at-edge">
        <AuthAtEdge />
      </section>
      <Code signIn={signIn} userProfile={userProfile} />
      <section className="mt-32 mb-16">
        <Powerful />
      </section>
      <Resources resources={resources} name="Next.js" />
      <section className="mt-16 mb-16" id="examples">
        <ExampleProjs />
      </section>
    </>
  );
}

export async function getStaticProps({ preview = false }) {
  const slug = '/solutions/nextjs-authentication';
  return singlePageProps({ preview, slug });
}
